@use 'tokens.module' as t;

.event,
:global(.event-session) {
  background-color: t.$white;
  border: 2px solid t.$grey-lighter;
  border-left-width: 1.25rem;
  border-radius: 4px;
  box-shadow: t.$box-shadow;
  height: 100%;
  padding: 1rem;
  width: 100%;
  z-index: 10;

}

.event-disabled,
:global(.event-session-disabled) {
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.6;
}

.event-radio,
:global(.event-session-radio) {
  margin-top: 6px;
}

.event-content,
:global(.event-session-content) {
  margin-left: 0.5rem;
}
